// Weglot pseudo-integration for the native localization modal.
// If Weglot is retired, remove this asset plus its script tags and the matching
// virtual language option in snippets/localization-modal.liquid.
window.FankaWeglotLocalizationBridge = {
  getCurrentLanguageValue(component) {
    if (
      this.getCurrentWeglotLanguage() === 'es' &&
      component.languageSelect?.querySelector('[data-weglot-language="es"]')
    ) {
      return 'weglot:es';
    }

    return component.getCurrentShopifyLanguage();
  },

  syncLanguageSelect(component) {
    if (!component.languageSelect) return false;

    const currentLanguage = this.getCurrentLanguageValue(component);
    const hasCurrentOption = Array.from(component.languageSelect.options).some(
      (option) => option.value === currentLanguage
    );

    if (hasCurrentOption) {
      component.languageSelect.value = currentLanguage;
    }

    component.selectedLanguage = component.languageSelect.value || currentLanguage;
    return true;
  },

  submitLanguageChange(component, language = component.selectedLanguage) {
    const option = this.getLanguageOption(component, language);

    if (option?.dataset.languageSystem === 'weglot') {
      this.submitWeglotLanguageChange(component, option.dataset.weglotLanguage || 'es');
      return true;
    }

    this.submitShopifyLanguageChange(component, option?.value || language);
    return true;
  },

  getLanguageOption(component, language) {
    if (!component.languageSelect) return null;

    return Array.from(component.languageSelect.options).find((option) => option.value === language) || null;
  },

  getCurrentWeglotLanguage() {
    const currentItem = document.querySelector(
      '.weglot_switcher [data-l].wgcurrent, .weglot_switcher .wgcurrent, .weglot_switcher [aria-current="true"], .weglot_switcher .active'
    );
    const currentLanguage =
      currentItem?.dataset?.l ||
      currentItem?.getAttribute('lang') ||
      currentItem?.querySelector('[lang]')?.getAttribute('lang') ||
      'en';

    return currentLanguage.toLowerCase().split('-')[0] === 'es' ? 'es' : 'en';
  },

  submitShopifyLanguageChange(component, language) {
    const nextLanguage = language || component.getCurrentShopifyLanguage();
    const currentLanguage = component.getCurrentShopifyLanguage();
    const languageInput = component.languageForm?.querySelector('input[name="locale_code"]');
    const shouldResetWeglot = this.getCurrentWeglotLanguage() === 'es';

    if (shouldResetWeglot) {
      this.switchWeglotLanguage(component, 'en');
    }

    if (nextLanguage !== currentLanguage && languageInput && component.languageForm) {
      languageInput.value = nextLanguage;
      setTimeout(() => {
        component.languageForm.submit();
      }, shouldResetWeglot ? 300 : 0);
      return;
    }

    if (shouldResetWeglot) {
      setTimeout(() => this.syncLanguageSelect(component), 300);
    }

    component.close();
  },

  submitWeglotLanguageChange(component, language = 'es') {
    const nextLanguage = language?.toLowerCase().split('-')[0] === 'es' ? 'es' : 'en';

    if (nextLanguage === this.getCurrentWeglotLanguage()) {
      this.syncLanguageSelect(component);
      component.close();
      return;
    }

    this.switchWeglotLanguage(component, nextLanguage);
    component.close();
  },

  switchWeglotLanguage(component, language, attempt = 0) {
    const target =
      document.querySelector(`#weglot-language-${language}`) ||
      document.querySelector(`.weglot_switcher [data-l="${language}"] a`) ||
      document.querySelector(`.weglot_switcher [data-l="${language}"]`) ||
      document.querySelector(`.weglot_switcher [lang="${language}"] a`) ||
      document.querySelector(`.weglot_switcher [lang="${language}"]`);

    if (target) {
      target.click();
      setTimeout(() => this.syncLanguageSelect(component), 300);
      return;
    }

    if (attempt < 20) {
      setTimeout(() => this.switchWeglotLanguage(component, language, attempt + 1), 250);
      return;
    }

    console.warn(`FankaWeglotLocalizationBridge: Weglot language "${language}" was not found`);
  },
};
